export default "__VITE_ASSET__6867ecc3__"